import { LandingPageDestination } from '@dtx-company/inter-app/src/types/flowcode'

export const isStaticRedirectType = (redirectType: LandingPageDestination): boolean => {
  return (
    redirectType === LandingPageDestination.EVENT || redirectType === LandingPageDestination.WIFI
  )
}
